exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".navbar .hamburger-container .icon{color:#8f8f8f;margin:0 !important}.navbar .hamburger-container .icon .mdi{font-size:large}", ""]);

// exports
